import { render, staticRenderFns } from "./ContactsView.vue?vue&type=template&id=15afe6a6"
import script from "./ContactsView.vue?vue&type=script&lang=ts"
export * from "./ContactsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports